import axios from 'axios'
import config from './../../config'
const { API: { BASE_URL } } = config
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 3000
})
export default api



// WEBPACK FOOTER //
// ./src/services/api/api.js